import { _ as __assign } from '../../chunks/bundle-BXYHgzRj.js';
import React__default from 'react';
import { G as GroupChannelHeaderView } from '../../chunks/bundle-CXwDMEak.js';
import { useChannelContext } from '../context.js';
import '../../ui/Icon.js';
import '../../chunks/bundle-u-vzK-oc.js';
import '../../ui/ChannelAvatar.js';
import '../../chunks/bundle-DGC3rWK4.js';
import '../../ui/ImageRenderer.js';
import '../../chunks/bundle-Dwpc_MJZ.js';
import '../../chunks/bundle-ydxNdZ_o.js';
import '../../chunks/bundle-DzMGbPvb.js';
import '../../chunks/bundle-DNnUvjnZ.js';
import '../../chunks/bundle-CqMQE3-R.js';
import '../../chunks/bundle-DtujCCHB.js';
import '../../useSendbirdStateContext.js';
import '../../withSendbird.js';
import '../../chunks/bundle-DWyboFhb.js';
import '../../ui/Header.js';
import '../../ui/TextButton.js';
import '../../chunks/bundle-DmX77DTu.js';
import '../../ui/IconButton.js';
import '../../chunks/bundle-CfyvTsrV.js';
import '@sendbird/uikit-tools';
import '../../chunks/bundle-Bd7J49Pj.js';
import '../../chunks/bundle-CGbKAqtd.js';
import '@sendbird/chat/groupChannel';
import '../../utils/message/getOutgoingMessageState.js';
import '../../chunks/bundle-CXA05pe2.js';
import '../../chunks/bundle-DokyceKk.js';
import '../../chunks/bundle-Dz4_R08c.js';
import 'react-dom';
import '../../ui/Button.js';
import 'css-vars-ponyfill';
import '@sendbird/chat';
import '../../chunks/bundle-ClfkSu0m.js';
import '@sendbird/chat/openChannel';
import '../../chunks/bundle-C4eUm39A.js';
import '../../chunks/bundle-CZybJwCN.js';
import '../../ui/SortByRow.js';
import '../../chunks/bundle-Cytf5OXn.js';
import '../../chunks/bundle-Bf00X-bc.js';
import '@sendbird/chat/message';
import '../../chunks/bundle-BKmrhRhi.js';
import '../../chunks/bundle-Bytw3a1z.js';
import '../../chunks/bundle-BqOj5e7u.js';
import '../../chunks/bundle-wIpBG4h1.js';
import '../../chunks/bundle-CXcQbCC8.js';
import '../../chunks/bundle-mZUrgg4o.js';
import '../../chunks/bundle-CeFR-WNJ.js';
import '../../chunks/bundle-CK28kSQl.js';
import '../../chunks/bundle-3OW5t08v.js';
import '../../chunks/bundle-CFXlbz6X.js';
import '../../chunks/bundle-DPABwR4A.js';

var ChannelHeader = function (_a) {
    var className = _a.className;
    var context = useChannelContext();
    return (React__default.createElement(GroupChannelHeaderView, __assign({}, context, { className: className, currentChannel: context.currentGroupChannel })));
};

export { ChannelHeader, ChannelHeader as default };
//# sourceMappingURL=ChannelHeader.js.map
